import React from 'react';
import {connect} from 'react-redux';
import properties from '../../constants/Properties';
import appParameters from '../utils/AppParameters';
import masterUniverseUtils from '../utils/MasterUniverseUtils';
import clipartParserJSONNew from '../accordion/clipartUtils/ClipartParserJSONNew';
import storeManager from '../../store/StoreManager';
import { OnOffToggleButton } from '../menus/OnOffToggleButton';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import { ListItemRenderer } from '../accordion/ListItemRenderer';
import locales from '../../locales/LocalesManager';
import modeType from '../../constants/ModeConstants';
import mouseUtils from '../utils/MouseUtils';
import {changeContextMode} from '../../actions/MenuActions';
import platformDetection from "../utils/PlatformDetection";

const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    shouldComponentUpdate(newProps) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 6
        };

        var caption = locales.getCaption('mainMenuFrames', 'hover');

        var closeButtonStyle = {
            position: 'absolute',
            width: 24,
            height: 24,
            top: 3,
            right: 28,
            cursor: 'pointer',
            borderStyle: 'none',
            background: 'none',
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 4,
            right: 4,
            cursor: 'pointer'
        };

        var ariaLabel = locales.getCaption('exit', 'other') + ' ' + caption;

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{caption}</span>
                <button id="firstFocusableObject" aria-label={ariaLabel} style={closeButtonStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>
        );
    }
});

const List = React.createClass({
    getInitialState() {
        return {
            currentPage: 0,
            dataProvider: this.props.dataProvider,
            elements: this.getCurrentElements(this.props.dataProvider, 0)
        };
    },
    uploadNewPage(scrollTop) {
        if (Math.abs(scrollTop - masterUniverseUtils.scrollPosition) < 40)
            return;

        masterUniverseUtils.scrollPosition = scrollTop;

        this.setState({
            elements: this.getCurrentElements(this.state.dataProvider, this.state.currentPage + 1),
            currentPage: this.state.currentPage + 1
        });
    },
    getCurrentElements(allElements, page) {
        var hitsPerPage = 50;
        var maxIndex = hitsPerPage * (page + 1);
        var items = [];

        for (var i=0; i<allElements.length; i++) {
            if (i < maxIndex)
                items.push(allElements[i]);
            else
                break;
        }

        return items;
    },
    render() {
        if (this.state == undefined || this.state.elements == undefined)
            return (<div/>);

        let items = this.state.elements;
        const paddingTop = 12;
        const paddingLeft = 3;
        var componentProperties = {};
        let elements = [];
        let i;

        for (i=0; i<items.length; i++) {
            const item = items[i];
            var key = 'item_' + Math.random() + '_' + i;

            elements.push(<ListItemRenderer item={item} key={key} isFrame={true} isBackground={true} usePagination={true} index={i} isSearch={true} parentWidth={this.props.width}/>);
        }

        componentProperties.paddingTop = paddingTop;
        componentProperties.paddingLeft = paddingLeft;
        componentProperties.width = this.props.width;
        componentProperties.top = this.props.top;
        componentProperties.displayState = 'inline-block';
        componentProperties.height = this.props.height;
        componentProperties.elements = elements;

        componentProperties.usePagination = true;
        componentProperties.uploadNewPage = this.uploadNewPage;

        var onOffButton;

        if (this.props.isBackgroundList) {
            var topGap = 0;
            var bottomGap = 0;
            var onOffButtonProperties = {};

            onOffButtonProperties.topPosition = componentProperties.top + topGap;
            onOffButtonProperties.leftPosition = properties.MY_MEDIA_FILES_GAP;
            onOffButtonProperties.trackWidth = properties.TOGGLE_TRACK_WIDTH;
            onOffButtonProperties.trackHeight = properties.TOGGLE_TRACK_HEIGHT;
            onOffButtonProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
            onOffButtonProperties.thumbSize = properties.TOGGLE_THUMB_SIZE;
            onOffButtonProperties.dispatch = this.props.dispatch;
            onOffButtonProperties.width = properties.BROWSER_WIDTH - 2 * properties.MY_MEDIA_FILES_GAP;

            onOffButtonProperties.isBackgroundElement = true;
            onOffButtonProperties.isFrame = true;
            onOffButtonProperties.useFrameAsImage = this.props.useFrameAsImage;

            onOffButton = <OnOffToggleButton properties={onOffButtonProperties} dispatch={this.props.dispatch}/>;

            var toggleButtonHeight = onOffButtonProperties.thumbSize + topGap + bottomGap;

            componentProperties.top = componentProperties.top + toggleButtonHeight;
            componentProperties.height = componentProperties.height - toggleButtonHeight;
        }

        return (
            <div>
                {onOffButton}
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});

export const LeftFramesMenuContent = React.createClass({
    componentDidMount() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('firstFocusableObject');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    getFrames() {
        if (!clipartParserJSONNew.frames)
            return [];

        var array = clipartParserJSONNew.frames.items;

        return array;
    },
    render() {
        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        var gap = 10;

        return (
            <div style={menuStyle}>
                <Title accordionWidth={this.props.accordionWidth}/>
                <List isBackgroundList={true} dispatch={this.props.dispatch} useFrameAsImage={this.props.useFrameAsImage} dataProvider={this.getFrames()} width={this.props.accordionWidth} top={gap + properties.CLIPART_BUTTON_HEIGHT} height={this.props.windowHeight - gap - properties.CLIPART_BUTTON_HEIGHT}/>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var useFrameAsImage = state.menu.useFrameAsImage;

    if (useFrameAsImage == undefined)
        useFrameAsImage = false;

    return {
        useFrameAsImage
    };
}

export const LeftFramesMenu = connect(mapStateToProps)(LeftFramesMenuContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/LeftFramesMenu.js
 **/